<template>
  <!-- <can I="edit" a="users"> -->
    <div class="wrapper">
      <div class="animated fadeIn">
        <b-card>
          <div slot="header">
            <b-row>
              <b-col cols="6">
                <span>{{ $t('global.user_profile_title') }}</span>
              </b-col>
            </b-row>
          </div>
          <div v-if="spinners.contentIsLoading" class="text-center">
            <b-spinner type="grow" variant="primary"/>
          </div>
          <div v-else>
            <b-row>
              <b-col cols="12" md="4">
                <b-form-group>
                  <label>{{ $t('global.name') }}</label>
                  <b-form-input type="text" :placeholder=" $t('global.name_placeholder') "
                                :class="{ 'is-invalid' : errorMsg.name }"
                                v-model="userEdit.name"/>
                  <div class="invalid-feedback" v-if="errorMsg.name">{{ errorMsg.name[0] }}</div>
                </b-form-group>

                <b-form-group>
                  <label>{{ $t('global.surname') }}</label>
                  <b-form-input type="text" :placeholder=" $t('global.surname_placeholder') "
                                :class="{ 'is-invalid' : errorMsg.surname }"
                                v-model="userEdit.surname"/>
                  <div class="invalid-feedback" v-if="errorMsg.name">{{ errorMsg.surname[0] }}</div>
                </b-form-group>

                <b-form-group>
                  <label>{{ $t('global.email') }}</label>
                  <b-form-input type="text" :placeholder=" $t('global.email_placeholder') "
                                :class="{ 'is-invalid' : errorMsg.email }"
                                v-model="userEdit.email"/>
                  <div class="invalid-feedback" v-if="errorMsg.email">{{ errorMsg.email[0] }}</div>
                </b-form-group>
              </b-col>
              <b-col cols="12" md="4">
                <b-form-group>
                  <label>{{ $t('global.roles') }}</label>
                  <treeselect :class="{ 'treeselect-error' : errorMsg.roles }"
                              :placeholder="$t('global.roles_placeholder')"
                              :multiple="true" :options="roleOptions" v-model="userEdit.roles" disabled/>
                </b-form-group>

                <b-form-group>
                  <label>{{ $t('global.extra_permissions') }}</label>
                  <treeselect :class="{ 'treeselect-error' : errorMsg.permissions }"
                              :placeholder="$t('global.permissions_placeholder')"
                              :multiple="true" :options="permissionsOptions" v-model="userEdit.permissions" disabled/>
                </b-form-group>
              </b-col>
              <b-col cols="12" md="4" class="split-line">
                  <h5>{{ $t('global.user_update_change_password') }}</h5>

                  <b-form-group>
                  <label>{{ $t('global.current_password') }}</label>
                  <b-form-input type="password"
                                :placeholder=" $t('global.current_password') "
                                :class="{ 'is-invalid' : errorMsg.current_password }"
                                v-model="userEdit.current_password"/>
                  <div class="invalid-feedback" v-if="errorMsg.current_password">{{ errorMsg.current_password[0] }}</div>
                </b-form-group>
                  <b-form-group>
                  <label>{{ $t('global.password') }}</label>
                  <b-form-input type="password"
                                :placeholder=" $t('global.password_placeholder') "
                                :class="{ 'is-invalid' : errorMsg.password }"
                                v-model="userEdit.password"/>
                  <div class="invalid-feedback" v-if="errorMsg.password">{{ errorMsg.password[0] }}</div>
                </b-form-group>

                <b-form-group>
                  <label>{{ $t('global.password_repeat') }}</label>
                  <b-form-input type="password"
                                :placeholder=" $t('global.password_repeat_placeholder') "
                                :class="{ 'is-invalid' : errorMsg.password }"
                                v-model="userEdit.password_confirmation"/>
                  <div class="invalid-feedback" v-if="errorMsg.password">{{ errorMsg.password[0] }}</div>
                </b-form-group>
              </b-col>
            </b-row>
          </div>
          <div slot="footer">
            <b-button type="submit" variant="primary" :disabled="spinners.isSaving" @click="onSave()">
              <b-spinner v-if="spinners.isSaving" type="grow" small/>
              {{ $t('global.save') }}
            </b-button>
            <router-link :to="{ name: 'Users'}">
              <b-button type="reset" variant="info" class="ml-2">
                {{ $t('global.cancel') }}
              </b-button>
            </router-link>
          </div>
        </b-card>
        <b-card>
          <b-row>
            <b-col>
              <h4>{{ $t('nav.refresh_token_list_title') }}</h4>
            </b-col>
            <b-col md="auto">
              <b-button-group>
                <b-button class="mb-3" variant="primary" :to="{ name: 'ApiTokenCreate' }">
                  {{ $t('api_token.create_new') }}
                </b-button>
              </b-button-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group>
                <b-table class="table-sm text-center" responsive outlined hover head-variant="light" :fields="fields" :items="refreshTokens">
                <template v-slot:cell(valid_until)="{value}">{{ momentf(value) }}</template>
                <template v-slot:cell(last_active_at)="{value}">{{ momentf(value) }}</template>
                  <template v-slot:cell(actions)="row">
                    <div class="flex-container options-center">
                      <Delete v-if="row.item.actions.delete" :id="row.item.id" @deleted="getData" :deleteFn="() => deleteRefreshToken(row.item.id)" />
                    </div>
                  </template>
                </b-table>
              </b-form-group>
            </b-col>
          </b-row>
        </b-card>
      </div>
    </div>
  <!-- </can> -->
</template>

<script>
import forEach from 'lodash.foreach';
import Treeselect from '@riophae/vue-treeselect';
import statuses from '@/store/statuses';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import { mapGetters, mapActions } from 'vuex';
import VT from '@/store/types';
import Delete from '@/views/Shared/ModalDelete';
import Services from '@/services/index';
import moment from 'moment';

export default {
  mounted() {
    this.getData();
  },
  data() {
    return {
      spinners: {
        contentIsLoading: true,
        isSaving: false,
      },
      isActive: null,
      userEdit: {
        name: '',
        surname: '',
        email: '',
        roles: [],
        permissions: [],
        current_password: null,
        password: null,
        password_confirmation: null,
      },
      refreshTokens: [],
      fields: [
        { key: 'id', label: this.$dt('user_profile.id', 'ID') },
        { key: 'token_type', label: this.$dt('user_profile.token_type', 'Token type') },
        { key: 'name', label: this.$dt('user_profile.name', 'Name') },
        { key: 'jti', label: this.$dt('user_profile.jti', 'TokenID JTI') },
        { key: 'valid_until', label: this.$dt('user_profile.valid_until', 'Valid until') },
        { key: 'last_active_at', label: this.$dt('user_profile.last_active_at', 'Last active at') },
        { key: 'actions', label: this.$t('global.options') },
      ],
      roleOptions: [],
      permissionsOptions: [],
      errorMsg: {}
    };
  },
  components: {
    Treeselect, Delete
  },
  computed: {
    ...mapGetters('Users', [
      'userUpdateData',
      'userProfileUpdate',
    ]),
    ...mapGetters('Auth', [
      'user',
    ]),
  },
  watch: {
    userUpdateData: {
      handler: function () {
        if (this.userUpdateData.status === statuses.LOADED) {
          this.fillData();
          this.spinners.contentIsLoading = false;
        }
      },
      deep: true
    },
    userProfileUpdate: {
      handler: function () {
        this.errorMsg = {};
        this.spinners.isSaving = false;
        if (this.userProfileUpdate.status === statuses.LOADED) {
          this.alertSuccess();
          this.getData();
        } else if (this.userProfileUpdate.status === statuses.ERROR) {
          this.alertError();
          this.errorMsg = this.userProfileUpdate.data.data.errors;
        }
      },
      deep: true
    },
  },
  methods: {
    ...mapActions('Users', [
      VT.USER_UPDATE_DATA,
      VT.USER_PROFILE_UPDATE,
    ]),
    getData() {
      this.USER_UPDATE_DATA(this.user.id);
      Services.auth.getRefreshTokens().then(async (resp) => {
        this.refreshTokens = resp.data.data;
        this.refreshTokens.forEach((element) => {
          element.unix_timestamp = moment(element.valid_until, 'DD.MM.YYYY hh:mm:ss').unix();
        });

        this.refreshTokens.sort((a, b) => {
          return b.unix_timestamp - a.unix_timestamp;
        });

        this.refreshTokens.map((a) => {
          const time_2 = moment().unix();
          if (a.unix_timestamp < time_2 || a.valid_until == null) {
            a._rowVariant = 'danger';
          }
        });
      });
    },
    fillData() {
      const user = JSON.parse(JSON.stringify(this.userUpdateData.data.user));
      const roles = JSON.parse(JSON.stringify(this.userUpdateData.data.roles));

      const disabledPermissions = [];
      this.isActive = user['is_active'];

      this.userEdit = {
        name: user['name'],
        surname: user['surname'],
        email: user['email'],
        roles: [],
        permissions: [],
      };

      const userRoles = [];
      if (user.roles.length) {
        forEach(user.roles, (role) => {
          userRoles.push(role['id']);

          if (role.permissions.length) {
            forEach(role.permissions, (permission) => {
              if (!disabledPermissions.includes(permission['id'])) {
                disabledPermissions.push(permission['id']);
              }
            });
          }
        });
        this.userEdit.roles = userRoles;
      }

      const userPermissions = [];
      if (user.permissions.length) {
        forEach(user.permissions, (permission) => {
          userPermissions.push(permission['id']);
        });
        this.userEdit.permissions = userPermissions;
      }
      this.fillRolesOptions(roles);
      this.fillPermissionsOptions(
        JSON.parse(JSON.stringify(this.userUpdateData.data.permissions)),
        disabledPermissions
      );
    },
    fillRolesOptions(roles) {
      const rolesOpt = [];
      forEach(roles, (role) => {
        rolesOpt.push({
          id: role['id'],
          label: this.$t(role['name'], 'global')
        });
      });
      this.roleOptions = rolesOpt;
    },
    fillPermissionsOptions(permissions, disabledPermissions) {
      const permissionsOpt = [];
      forEach(permissions, (permission) => {
        let isDisabled = false;

        if (disabledPermissions.includes(permission['id'])) {
          isDisabled = true;
        }
        permissionsOpt.push({
          id: permission['id'],
          label: permission['name'],
          isDisabled: isDisabled
        });
      });
      this.permissionsOptions = permissionsOpt;
    },
    onSave() {
      this.spinners.isSaving = true;
      this.USER_PROFILE_UPDATE({ id: this.user.id, update: this.userEdit });
    },

    deleteRefreshToken(tokenId) {
      return Services.auth.deleteRefreshToken(tokenId);
    }
  }
};
</script>

<style scoped>
@media screen and (min-width: 768px) {
  .split-line {
      border-left: 1px solid lightgrey;
  }
}
@media screen and (max-width: 767px) {
  .split-line {
      border-top: 1px solid lightgrey;
      margin-top: 20px;
      padding-top: 20px;
  }
}
</style>
